import React from "react";

// Simple Header component that we gonna render later in the UI.
function Header() {
  return (
    <header>
      <h1>GlobalLogic Company Staff, Inc.</h1>
    </header>
  );
}

export default Header;
